export const motion = {
  duration: {
    instant: 100,
    fast: 150,
    normal: 200,
    slow: 300,
  },
  // CSS easing strings (for web platform)
  easing: {
    enter: 'cubic-bezier(0.19, 1, 0.22, 1)',
    exit: 'cubic-bezier(0.8, 0, 0.4, 1)',
    move: 'cubic-bezier(0.65, 0, 0.35, 1)',
  },
  // Reanimated-compatible spring configs (for native platform)
  spring: {
    button: { damping: 15, stiffness: 400, mass: 0.5 },
    gentle: { damping: 20, stiffness: 200, mass: 1 },
    snappy: { damping: 20, stiffness: 500, mass: 0.5 },
  },
  press: {
    scale: 0.97,
    scaleSmall: 0.95,
  },
};
